import {
  SET_ACCOUNT_ASSISTANT_CONVERSATION,
  SET_ACCOUNT_ASSISTANT_VIEW,
  SET_ACCOUNT_ASSISTANT_QUERIES,
  SET_ACCOUNT_ASSISTANT_EXPANDED,
  SET_ACCOUNT_ASSISTANT_OPEN,
  SET_ACCOUNT_ASSISTANT_STREAMING_QUERY,
  SET_SPOTLIGHT_DATA
} from '../actions/constants';

const initialState = {
  conversation_id: null,
  view: 'conversation', // 'threads' or 'conversation'
  queries: [], // All account assistant queries from database
  expanded: false,
  isOpen: false,
  streamingQuery: null, // For external sources (SpotlightSearch) to trigger streaming
  spotlightData: null // Shallow { projects, documents, queries } from /projects/spotlight-data
};

const accountAssistantReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACCOUNT_ASSISTANT_CONVERSATION:
      return {
        ...state,
        conversation_id: action.payload
      };
    
    case SET_ACCOUNT_ASSISTANT_VIEW:
      return {
        ...state,
        view: action.payload
      };
    
    case SET_ACCOUNT_ASSISTANT_QUERIES:
      return {
        ...state,
        queries: Array.isArray(action.payload) ? action.payload : (action.payload.queries || [])
      };
    
    case SET_ACCOUNT_ASSISTANT_EXPANDED:
      return {
        ...state,
        expanded: action.payload
      };
    
    case SET_ACCOUNT_ASSISTANT_OPEN:
      return {
        ...state,
        isOpen: action.payload
      };
    
    case SET_ACCOUNT_ASSISTANT_STREAMING_QUERY:
      return {
        ...state,
        streamingQuery: action.payload
      };

    case SET_SPOTLIGHT_DATA:
      return {
        ...state,
        spotlightData: action.payload
      };

    default:
      return state;
  }
};

export default accountAssistantReducer;
